import { render, staticRenderFns } from "./OrderAndInvoices.vue?vue&type=template&id=33a1182e&scoped=true"
import script from "./OrderAndInvoices.vue?vue&type=script&lang=js"
export * from "./OrderAndInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1182e",
  null
  
)

export default component.exports